import { vhSiteBaseInfoPostMessage } from '@/app-shared/utils/common';

/**
 * 全局嵌入场景，嵌入页加载完毕后，向父级页面发送站点基本信息 post message
 * 业务场景：
 * 1、全局嵌入场景，设置当前浏览器标题
 * 2、全局嵌入场景，页面微信分享
 * @param roomBaseServer
 */
export function vhSiteBaseInfoHandle(roomBaseServer) {
  const curLangInfo = roomBaseServer.state.languages?.curLang;
  const lang = curLangInfo?.language_type === 2 ? 'en' : 'zh';
  let nameZH = '';
  let nameEN = '';
  if (lang === 'en') {
    nameEN = curLangInfo?.subject;
  } else {
    nameZH = curLangInfo?.subject;
  }
  // 微信、企业微信初始化后，会初始化 window.wxShareConfig
  try {
    const opt = {
      business_id: Number(sessionStorage.getItem('initGrayId')), //B租户ID
      site_id: Number(roomBaseServer.state.watchInitData?.webinar?.id), //站点id
      site_type: 4, //  1：单场大会 2: 系列会 3: 聚合站点 4: 网络研讨会
      cover: roomBaseServer.state.watchInitData?.webinar?.subject, // 站点封面
      language: lang, //站点语言 zh: 中文；en：英文
      name_zh: nameZH, //中文站点名称
      name_en: nameEN, //英文站点名称
      wx_config: {
        // 微信分享设置
        zh: {
          title: window.wxShareConfig?.zh?.title || '', //标题
          introduction: window.wxShareConfig?.zh?.introduction || '', //简介
          cover: window.wxShareConfig?.zh?.cover || '' //图片
        },
        en: {
          title: window.wxShareConfig?.en?.title || '', //标题
          introduction: window.wxShareConfig?.en?.introduction || '', //简介
          cover: window.wxShareConfig?.en?.cover || '' //图片
        }
      }
    };

    vhSiteBaseInfoPostMessage(opt);
  } catch (e) {
    console.error('vhSiteBaseInfoHandle err:', e);
  }
}
